import AmountForm from "../containers/deposit/amount-form";
import classes from "../classes";
import { connect } from "react-redux";
import { getSession } from "../selectors";
import HowToPlay from "../components/how-to-play";
import { Link, Redirect } from "react-router-dom";
import React from "react";

class WelcomePage extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      howToExpanded: false
    };
    this.expandHowTo = this.expandHowTo.bind(this);
  }

  expandHowTo() {
    this.setState({ // eslint-disable-line react/no-set-state
      howToExpanded: true
    });
  }

  render() {
    var { session } = this.props;
    var { howToExpanded } = this.state;

    if (session.get("user_id") === undefined) {
      return <Redirect to="/sign-up" />;
    }

    var hasNoAddress = session.getIn(["billing_address", "state"]) === null;
    var canDeposit = session.get("abilities").contains("make deposits") || hasNoAddress;
    if (!canDeposit) {
      return <Redirect to="/tournaments" />;
    }

    return (
      <div>
        <div className="l-row">
          <div className="l-wrapper">
            <div className="l-content l-content--80-percent text-center">
              <h1>
                Welcome to
                {window.env.brandName}
                !
              </h1>

              <h2>
                Deposit now and start winning cash today!
              </h2>

              <AmountForm buttonLabel="Deposit Now" largeButton />

              <div>
                <a
                  className="link--is-underlined link--is-inline"
                  href="#how-to-play"
                  onClick={this.expandHowTo}>
                  How to play
                </a>

                <Link className="link--is-white link--is-inline" to="/">
                  View Contests
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div
          className={classes({
            "collapsable": true,
            "collapsable--is-open": howToExpanded
          })}
          id="how-to-play">
          <HowToPlay />
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    session: getSession(state)
  };
}

export default connect(select)(WelcomePage);
